import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { CSSProperties, useEffect, useState, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { IOptionsProps } from '../../../../@types/reactSelect/IOption'
import { useEditOnboarding } from '../../../../hooks/useEditOnboarding'
import { useAuth } from '../../../../hooks/useAuth'
import { farmService } from '../../../../services/farmService'
import { areaService } from '../../../../services/areaService'
import { calculateHectares } from '../../../../utils/geolib/calculateHectares'
import { Input } from '../../components/Input'
import { InputIcon } from '../../components/InputIcon'
import { Dropdown } from '../../components/Select'
import { FooterEditOnboarding } from '../../Footer'
import './styles.css'
import { DrawOnMap } from '../../components/DrawOnMap/DrawOnMap'
import { ReactComponent as Available } from '../../../../assets/svg/icons/available.svg'
import { ReactComponent as Unvailable } from '../../../../assets/svg/icons/unavailable.svg'
import { ICoords } from '../../../../@types/GoogleMaps/ICoord'
import { Chips } from '../../../Chips'
import { AlertModal } from '../../../Modal/Alert/Index'
import { SimpleButtonClose } from '../../../Modal/Contents/SimpleButtonClose/Index'
import { TextModal } from '../../../Modal/Contents/TextModal/Index'
import { TitleModal } from '../../../Modal/Contents/TitleModal/Index'
import { ButtonRedirect } from '../../../Modal/Error/ButtonRedirect/Index'
import { moveCharLeft } from '../../../../utils/arrays/moveChar'
import { microAreaService } from '../../../../services/microAreaService'

export function MicroArea() {
  const microAreaSchema = yup.object().shape({
    farm: yup
      .object({
        label: yup.string(),
        value: yup.string().required('Fazenda é necessária.'),
      })
      .nullable()
      .required('Fazenda é necessária.'),
    area: yup
      .object({
        label: yup.string(),
        value: yup.string().required('Retiro é necessário.'),
      })
      .nullable()
      .required('Retiro é necessário.'),
    initials: yup
      .string()
      .matches(/^\S+(\s+\S+)*$/, 'Esta sigla não é válida.')
      .required('Sigla é necessário.'),
    acreage: yup
      .string()
      .test('value', 'Campo obrigatório não informado. ', () => {
        if (Number(acreageInput?.replace(',', '.')) === 0) return false
        return true
      })
      .test(
        'value',
        'O espaço disponível neste retiro foi ultrapassado',
        () => {
          if (Number(remainingArea) >= 0) return true
          return false
        },
      )
      .required('Campo obrigatório não informado.'),
    map_coords: yup
      .array()
      .of(
        yup.object({
          lat: yup.number(),
          lng: yup.number(),
        }),
      )
      .test('is-null', 'Selecione a fazenda e o retiro para realizar o desenho da área no mapa.', (value) =>
        value ? value.length > 0 : true,
      ),
  })

  const { setOptionForm, defaultValue } = useEditOnboarding()
  const { user } = useAuth()
  const [reasonOptions, setReasonOptions] = useState<IOptionsProps>()
  const [listFarms, setListFarms] = useState<IOptionsProps>()
  const [listAreas, setListAreas] = useState<IOptionsProps>()
  const [currentFarm, setCurrentFarm] = useState<any>()
  const [currentArea, setCurrentArea] = useState<any>()
  const [currentInitials, setCurrentInitials] = useState<string>('')
  const isNew = !defaultValue
  const [microAreaCoords, setMicroAreaCoords] = useState<ICoords>([])
  const [staticMicroAreas, setStaticMicroAreas] = useState<ICoords[]>([])
  const [acreageArea, setAcreageArea] = useState('')
  const [msgError, setMsgError] = useState<string>('')
  const [initialsOnlyRead, setInitialsOnlyRead] = useState<boolean>(true)
  const [lenghtMicroArea, setLenghtMicroArea] = useState(0)
  const [submiting, setSubmiting] = useState(false);

  const formDefaultValues = useMemo(() => {
    if (!defaultValue) {
      return {
        farm: null,
        area: null,
        initials: '',
        acreage: '',
        map_coords: [],
        reason: null
      }
    }
    
    const farm = listFarms?.find(f => f.value === defaultValue.farm_id) || null;
    const area = listAreas?.find(a => a.value === defaultValue.area_id) || null;
    const reason = reasonOptions?.find(r => r.value === defaultValue.reason_id) || null;
    
    const acreageValue = defaultValue.acreage || '';

    return {
      farm,
      area,
      initials: defaultValue.initials || '',
      acreage: acreageValue,
      map_coords: defaultValue.map_coords || [],
      reason
    }
  }, [defaultValue, listFarms, listAreas, reasonOptions])

  const contentStyleAlert = {
    width: '335px',
    height: '237px',
    borderRadius: '20px',
    padding: '20px',
  } as CSSProperties

  const {
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: formDefaultValues,
    resolver: yupResolver(microAreaSchema),
  })
  const acreageInput = watch('acreage')
  const initialsInput = watch('initials')

  const onSubmit = (data: any) => {
    setSubmiting(true);
    
    var acreageFix = data?.acreage?.replace(',', '.')
    if (isNew) {
      var formNewMicroArea = [
        {
          initials: data?.initials,
          acreage: moveCharLeft(acreageFix, acreageFix.charAt(2)),
          area_id: data?.area?.value,
          map_coords: data?.map_coords,
          micro_area_reason_id: data?.reason?.value,
        },
      ]
      microAreaService
        .createMicroAreas(formNewMicroArea)
        .then(() => {
          setOptionForm(undefined)
        })
        .catch((error) => setMsgError(error.response.data.msg))
        .finally(() => {
          setSubmiting(false)
        })
    } else {
      var formPathMicroArea = [
        {
          micro_area_id: defaultValue?.id,
          initials: data?.initials,
          acreage: moveCharLeft(acreageFix, acreageFix.charAt(2)),
        },
      ]
      microAreaService
        .updateMicroAreas(formPathMicroArea)
        .then(() => {
          setOptionForm(undefined)
        })
        .catch((error) => setMsgError(error.response.data.msg))
        .finally(() => {
          setSubmiting(false)
        })
    }
  }

  useEffect(() => {
    microAreaService.getMicroAreasReasons().then((data) => {
      setReasonOptions(
        data.map((option: any) => ({
          value: option.id,
          label: option.description,
        })),
      )
    })

    farmService.getFarmsByUser().then((data) => {
      setListFarms(
        data.map((farm: any) => ({
          label: farm.name,
          value: farm.id,
          info: farm,
        })),
      )
    })

    areaService.getAreasByUser().then((data) => {
      setListAreas(
        data.map((area: any) => ({
          label: area.name,
          value: area.id,
          info: area,
        })),
      )
    })
  }, [])

  useEffect(() => {
    if (currentFarm) {
      setCurrentInitials(`${currentFarm?.initials}`)
    }
  }, [currentFarm])

  useEffect(() => {
    if (!isNew && defaultValue && listFarms && listFarms.length > 0 && listAreas && listAreas.length > 0) {
      // Buscar a fazenda
      const farm = listFarms.find(f => 
        f.value === defaultValue.farm_id || 
        f.info?.initials === defaultValue.farm_initials
      )
      if (farm) {
        setCurrentFarm(farm.info)
        setValue('farm', farm)
      }
      
      // Buscar a área
      const area = listAreas.find(a => 
        a.value === defaultValue.area_id || 
        a.info?.initials === defaultValue.area_initials
      )
      if (area) {
        setCurrentArea(area.info)
        setValue('area', area)
      }
    }
  }, [isNew, defaultValue, listFarms, listAreas, setValue])

  useEffect(() => {
    setAcreageArea(defaultValue?.remaining_area)
  }, [defaultValue])

  // Calcula hectares automaticamente quando usuário desenha no mapa
  useEffect(() => {
    const mapCoords = watch('map_coords');
    const currentAcreage = watch('acreage');
    
    if (mapCoords && mapCoords.length >= 3 && (!currentAcreage || currentAcreage === '0.00')) {
      const calculatedAcreage = calculateHectares(mapCoords);
      setValue('acreage', calculatedAcreage);
    }
  }, [watch('map_coords'), setValue])

  useEffect(() => {
    if (listFarms && listAreas && reasonOptions) {
      reset(formDefaultValues)
    }
  }, [defaultValue, listFarms, listAreas, reasonOptions, reset])

  // Deriva o valor de `remainingArea` a partir do total disponível e do valor
  // digitado em `acreage`. Usamos `useMemo` para evitar condições de corrida
  // entre efeitos assíncronos que atualizam `acreageArea`.
  const remainingArea = useMemo(() => {
    if (!(currentArea || defaultValue?.area_id)) return ''

    const areaTotal = Number(acreageArea) || Number(currentArea?.acreage) || 0
    let currentAcreageNumber = 0

    if (acreageInput !== undefined && acreageInput !== null && acreageInput !== '') {
      const acreageStr = String(acreageInput).replace(',', '.')
      const parsed = Number(moveCharLeft(acreageStr, acreageStr.charAt(2)))
      currentAcreageNumber = isNaN(parsed) ? 0 : parsed
    }

    return (areaTotal - currentAcreageNumber).toFixed(2)
  }, [acreageInput, acreageArea, currentArea, defaultValue?.area_id])

  const deleteMicroArea = () => {
    microAreaService
      .deleteMicroArea(defaultValue.id)
      .then(() => {
        setOptionForm(undefined)
      })
      .catch((err) => setMsgError(err.response.data.msg))
  }


  useEffect(() => {
    if (initialsOnlyRead) {
      if (isNew)
        setValue(
          'initials',
          `${(lenghtMicroArea + 1).toString().padStart(3, '0')}`,
        )
      else setValue('initials', defaultValue?.initials)
    }
  }, [initialsOnlyRead, lenghtMicroArea])

  useEffect(() => {
    if (currentArea) {
      setCurrentInitials(`${currentFarm?.initials}-${currentArea?.initials}`)
      setMicroAreaCoords([...currentArea.map_coords, currentArea.map_coords[0]])
      
      // Buscar microáreas existentes para o mapa
      microAreaService
        .getMicroAreasByAreaId(currentArea.id)
        .then((data) => {
          const otherMicroAreas = data.filter((micro) => micro.id !== defaultValue?.id)
          setStaticMicroAreas(otherMicroAreas.map((micro) => micro.map_coords))
        })
      
      // Buscar dados para cálculo de área restante
      microAreaService
        .getMicroAreasByFarmAndArea(currentFarm?.id, currentArea?.id)
        .then((data) => {
          // Excluir a microárea atual quando estivermos editando, para que o
          // cálculo da área disponível não subtraia a mesma área duas vezes.
          const otherMicroAreas = data.filter((micro: any) => micro.id !== defaultValue?.id)
          const acregeUsed = otherMicroAreas.reduce(
            (sum: number, current: any) => sum + current.acreage,
            0,
          )
          setLenghtMicroArea(otherMicroAreas.length)
          setAcreageArea((currentArea?.acreage - acregeUsed).toFixed(2))
        })
    }
  }, [currentArea, currentFarm])

  useEffect(() => {
    if (!!initialsInput) setValue('initials', initialsInput.toLocaleUpperCase())
  }, [initialsInput])

  return (
    <>
      <AlertModal visible={!!msgError} contentStyle={contentStyleAlert}>
        <section className="EditAreas_modalalert-container">
          <SimpleButtonClose onClick={() => setMsgError('')} />
          <main className="EditAreas_modalalert-content">
            <TitleModal>Algo deu errado.</TitleModal>
            <TextModal>{msgError}</TextModal>
          </main>
          <ButtonRedirect onClick={() => setMsgError('')}>
            Voltar
          </ButtonRedirect>
        </section>
      </AlertModal>
      <main className={'body__formEditOnboarding'}>
        <div className="firstColumn">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Dropdown
              control={control}
              label={'Fazenda'}
              placeholderText={'Selecione...'}
              options={listFarms}
              isDisabled={!isNew}
              getSelectedData={(option: any) => {
                setCurrentFarm(option.info)
              }}
              closeMenuOnSelect={true}
              errorText={(errors?.farm as any)?.value?.message}
              name={'farm'}
            />
            <Dropdown
              control={control}
              label={'Retiro'}
              placeholderText={'Selecione...'}
              options={
                listAreas
                  ? listAreas.filter(
                    (area: any) => area?.info?.farm?.id === currentFarm?.id,
                  )
                  : []
              }
              getSelectedData={(option: any) => {
                setCurrentArea(option.info)
              }}
              isDisabled={!isNew}
              closeMenuOnSelect={true}
              errorText={(errors?.area as any)?.value?.message}
              name={'area'}
              noOptionsMessage={() => <span>Nenhum retiro disponível</span>}
            />

            <Input
              control={control}
              label={'Sigla'}
              theme={initialsOnlyRead ? 'read-only' : 'normal'}
              disabled={initialsOnlyRead}
              labelPrefix={`${isNew
                  ? currentInitials
                    ? `${currentInitials}-`
                    : ''
                  : `${defaultValue?.farm_initials}-${defaultValue?.area_initials}-`
                }`}
              overrideStyles={{
                input: {
                  width: 200,
                },
              }}
              maxLength={4}
              errorText={errors?.initials?.message as any}
              name={'initials'}
            />

              <label
                onClick={() => setInitialsOnlyRead(!initialsOnlyRead)}
                className="initial--readOnly"
                hidden={user?.role !== 'MASTER'}
              >
                {initialsOnlyRead ? 'Alterar sigla' : 'Usar sigla automática'}
              </label>

            <div>
              <label className="acreageLabel">
                Quantos hectares de área útil?
              </label>

              <div className="hectares__container">
                <Input
                  name={'acreage'}
                  theme={'normal'}
                  label={''}
                  type={'number'}
                  control={control}
                  disabled={false}
                  prefixPosition="right"
                  labelPrefix="ha"
                  overrideStyles={{
                    prefixLabel: {
                      color: '#999999',
                    },
                    input: {
                      width: 120,
                      maxWidth: 200,
                    },
                    contentInput: {
                      width: 200,
                      marginRight: 20,
                    },
                  }}
                  errorText={(errors?.acreage as any)?.message ? ' ' : ''}
                />

                <InputIcon
                  theme={'normal'}
                  control={control}
                  disabled={true}
                  className={'microarea__container__icon'}
                  labelPrefix={`${remainingArea} disponíveis`}
                  Icon={Number(remainingArea) >= 0 ? Available : Unvailable}
                  prefixPosition={'right'}
                  name={'remainingArea'}
                  overrideStyles={{
                    prefixLabel: {
                      maxWidth: 200,
                      minWidth: 200,
                    },
                    input: {
                      width: 10,
                    },
                    container: {
                      width: 280,
                    },
                  }}
                />
              </div>
            </div>

            {errors?.acreage ? (
              <small className="textInput--small-error animation__fadeIn">
                {(errors?.acreage as any)?.message}
              </small>
            ) : (
              ''
            )}

            {isNew || defaultValue?.reason_id ? (
              <Dropdown
                label={'Motivo para não utilizar o pasto'}
                closeMenuOnSelect={true}
                control={control}
                options={reasonOptions}
                isDisabled={!isNew}
                isSearchable={isNew}
                errorText={(errors?.reason as any)?.value?.message}
                name={'reason'}
                placeholderText={'Selecione...'}
              />
            ) : null}
          </form>
        </div>
        <div className="secondColumn">
          <div className="draw-on-map-container">
            <form onSubmit={handleSubmit(onSubmit)}>
              <DrawOnMap
                staticsElements={staticMicroAreas}
                style={{ width: '400px', height: '300px' }}
                mainPolygon={[]}
                initialsLabel={`${currentInitials}-${initialsInput || ''}`}
                control={control}
                fitCoords={currentArea?.map_coords}
                name={'map_coords'}
                editable={isNew && currentArea}
              />
            </form>
          </div>
          <div className="microareas-list">
            <ul>
              {defaultValue?.batch_initials ? (
                <li>
                  <Chips.Pressable
                    variationStyles={{ container: { width: '100%' } }}
                    theme={'link-light'}
                    label={`${defaultValue?.farm_initials}-${defaultValue?.area_initials}-${defaultValue?.batch_initials}`}
                  />
                </li>
              ) : null}
            </ul>
          </div>
        </div>
      </main>

      <FooterEditOnboarding
        undoFunction={() => setOptionForm(undefined)}
        saveFunction={handleSubmit((data)=>{
          console.log(submiting)
          if(!submiting){
            onSubmit(data)
          }
        })}
        deleteFunction={deleteMicroArea}
        isNew={isNew}
        disabledSubmit={submiting}
      />
    </>
  )
}
